import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import { KpiCard, ToggleBarChart, DonutBreakdownCard } from '../../../common/analytics';
import { MONETIZATION_KPI_ICONS, VOLUME_COUNT_TOGGLES, MONTH_QUARTER_TOGGLES } from '../../dashboard.constants';
import CardSkeleton from '../../../common/cardSkeleton/CardSkeleton';
import styles from './styles/detailed-metrics-section.module.scss';

function DetailedMetricsSection({ kpis = [], advancesByType, avgUserMetrics, loading = false }) {
    return (
        <section className={styles.section}>
            <Text as="span" size="xs" className={styles.sectionLabel}>Detailed Metrics</Text>

            {loading ? (
                <>
                    <div className={styles.kpiRow}>
                        <CardSkeleton minHeight={150} rows={1} />
                        <CardSkeleton minHeight={150} rows={1} />
                        <CardSkeleton minHeight={150} rows={1} />
                        <CardSkeleton minHeight={150} rows={1} />
                    </div>
                    <div className={styles.splitRow}>
                        <CardSkeleton minHeight={420} rows={6} />
                        <CardSkeleton minHeight={420} rows={6} />
                    </div>
                </>
            ) : (
                <>
            <div className={styles.kpiRow}>
                {kpis.map((kpi) => (
                    <KpiCard
                        key={kpi.key}
                        label={kpi.label}
                        value={kpi.value}
                        variant={kpi.variant}
                        conversionRate={kpi.conversionRate}
                        icon={MONETIZATION_KPI_ICONS[kpi.key]}
                        isCurrency={kpi.isCurrency}
                    />
                ))}
            </div>

            <div className={styles.splitRow}>
                <DonutBreakdownCard
                    title={advancesByType.title}
                    subtitle={advancesByType.subtitle}
                    total={advancesByType.total}
                    totalLabel={advancesByType.totalLabel}
                    segments={advancesByType.segments}
                />
                <ToggleBarChart
                    title={avgUserMetrics.title}
                    subtitle={avgUserMetrics.subtitle}
                    toggles={VOLUME_COUNT_TOGGLES}
                    defaultToggle="volume"
                    secondaryToggles={MONTH_QUARTER_TOGGLES}
                    defaultSecondaryToggle="monthly"
                    series={avgUserMetrics.series}
                    data={avgUserMetrics.data}
                    showLegend={false}
                />
            </div>
                </>
            )}
        </section>
    );
}

export default DetailedMetricsSection;
